import { BidPack } from "./BidPack";
import { BidPackDestination } from "./BidPackDestination";
import { BidPackOriginRegion } from "./BidPackOriginRegion";

export interface BidPackWriteRequest {
  Id: number;
  Name: string;
  StartDate: Date | null;
  EndDate?: Date | null;
  TransportType: number;
  EquipmentIds: Array<number>;
  DestinationName: string;
  Destinations: Array<BidPackDestination>;
  OriginRegions: Array<BidPackOriginRegion>;
}

export const toBidPackWriteRequest = (bidPack: BidPack): BidPackWriteRequest => {
  return {
    Id: bidPack.Id,
    Name: bidPack.Name,
    StartDate: bidPack.StartDate,
    EndDate: bidPack.EndDate,
    TransportType: bidPack.TransportType,
    EquipmentIds: bidPack.EquipmentIds,
    DestinationName: bidPack.DestinationName,
    Destinations: bidPack.Destinations,
    OriginRegions: bidPack.OriginRegions,
  };
};
